import React from "react";
import { ConfirmationDialog } from "../common/VFX-UI";
import { ResendVerificationProps } from "../../types";

const ResendVerification: React.FC<ResendVerificationProps> = ({
  isResendVerification,
  userName,
  handleOnClose,
  handleOnConfirm,
}) => {
  return (
    <ConfirmationDialog
      open={isResendVerification}
      onClose={handleOnClose}
      onConfirm={handleOnConfirm}
      contentTitle="Resend Email"
      contentText={`Are you sure you want to resend confirmation email to ${userName}`}
      confirmText={"Confirm"}
      closeText={"Cancel"}
    ></ConfirmationDialog>
  );
};

export default ResendVerification;
